import PropTypes from 'prop-types';

const LoadingSpinner = ({ size = 'default', className = '' }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-4 border-green-200 border-t-green-900 rounded-full animate-spin`}
        role="status"
        aria-label="Cargando..."
      >
        <span className="sr-only">Cargando...</span>
      </div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'large']),
  className: PropTypes.string,
};

export default LoadingSpinner;